import { Directive, Input, HostBinding } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Directive({
    selector: '[appSaveButtonFormValidity]'
})
export class SaveButtonFormValidityDirective {
    @Input() public form: FormGroup;

    @HostBinding('class')
    public get buttonValidityClass(): string {
        return this.form.valid ? 'green' : 'invalid';
    }
}
